export const flags = {
  emailMarketingV2: 'commx-email-marketing-v2',
};
